import { createContext, useState } from 'react';

const NavLinkContext = createContext();

export function NavLinkProvider({ children }) {
  const pathName = window.location.pathname
  const slicedPathName = pathName.slice(1)
  const [navLinkColor, setNavLinkColor] = useState(slicedPathName);

  //* For future - on load check route, and apply the navlinkcolor to the route because on refresh
  //* It defaults back to 'home' even though you're on another route. 

  return (
    <NavLinkContext.Provider value={{ navLinkColor, setNavLinkColor }}>
      {children}
    </NavLinkContext.Provider>
  );
}

export default NavLinkContext;

